<script setup lang="ts">
const props = withDefaults(defineProps<{
  size?: "sm" | "md" | "lg";
}>(), {
  size: "md"
});
</script>

<template>
  <div :class="['spinner', `spinner--${props.size}`]" />
</template>

<style lang="scss" scoped>
.spinner {
  border-radius: 50%;
  // !important flag needed to override the below border styles
  border-left-color: map.get(v.$primary, "500") !important;
  animation: spin 1s ease infinite;
  &--sm {
    border: 2px solid map.get(v.$gray, "200");
    width: 24px;
    height: 24px;
  }
  &--md {
    border: 4px solid map.get(v.$gray, "200");
    width: 40px;
    height: 40px;
  }
  &--lg {
    border: 6px solid map.get(v.$gray, "200");
    width: 64px;
    height: 64px;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
